import React from "react";
import { useLocalization } from "@fluent/react";
import type OrganizationUser from "byzantine/src/OrganizationUser";
import { Chip, LoadingShim } from "@narmi/design_system";

import { useCurrentUser } from "../contexts/CurrentUserContext";
import {
  BYZANTINE_COPY_TO_FLUENT_ID,
  STATUS_CHIP_KINDS,
  STATUS_CHIP_ICONS,
} from "./OrganizationUsers.constants";

interface OrganizationUserMobileRowProps {
  member: OrganizationUser;
  onRowClick?: (user: OrganizationUser) => void;
}

const OrganizationUserMobileRow: React.FC<OrganizationUserMobileRowProps> = ({
  member,
  onRowClick,
}) => {
  /* the responsive version of `OrganizationUserRow`
     note that it currently does not display the reason a row is uneditable
   */
  const { currentUser } = useCurrentUser();
  const { l10n } = useLocalization();

  if (!currentUser) {
    return <LoadingShim {...({ loading: true } as any)} />;
  }

  const goToEditUser = () => {
    onRowClick?.(member);
  };

  return (
    <div
      className="mobileListContents"
      role="button"
      tabIndex={0}
      onKeyUp={({ key }) => {
        if (key === "Enter") {
          goToEditUser();
        }
      }}
      onClick={() => {
        goToEditUser();
      }}
    >
      <div className="titleLine">
        <div className="statusChipWrap">
          <Chip
            startIcon={STATUS_CHIP_ICONS[member.status] as any}
            kind={STATUS_CHIP_KINDS[member.status] as any}
            label={l10n.getString(BYZANTINE_COPY_TO_FLUENT_ID[member.status])}
            isLabelVisible={false}
          />
        </div>
        <div className="titleLineText">
          <div className="memberText">
            <div className="name">
              {member.user.first_name} {member.user.last_name}
            </div>
            <div>{member.user.email}</div>
          </div>
          <span>{member.role.getDisplayName()}</span>
        </div>
      </div>
    </div>
  );
};

export default OrganizationUserMobileRow;
